/**
 * Where the Kourai API lives. `WXT_PUBLIC_API_URL` wins when set. Otherwise a page served over
 * http(s) is the website the Worker serves itself, so the API is on the same origin; the extension
 * (chrome-extension://, moz-extension://) falls back to the local API.
 *
 * @public exported for its test
 */
export function resolveApiUrl(
  configured: string | undefined,
  location: Pick<Location, "protocol" | "origin"> | undefined,
): string {
  if (configured) return configured;
  if (location && (location.protocol === "http:" || location.protocol === "https:")) {
    return location.origin;
  }
  return "http://localhost:8787";
}

export const API_URL = resolveApiUrl(
  import.meta.env.WXT_PUBLIC_API_URL,
  typeof window === "undefined" ? undefined : window.location,
);
